module.exports = __webpack_public_path__ + "epdf-app/dashboard/depositor/depositor-details-3XSIeKkS.html";